<template>
  <div>
    <el-upload :class="[{ hide: isHide },'upload']" action="#" :limit="limit" :on-change="handleChange" :http-request="handleFileUpload" :file-list="fileList" :show-file-list="false" v-bind="$attrs" v-on="$listeners">
      <el-button type="primary">{{btnAttrs.btnText}}</el-button>
      <div slot="tip" v-if="btnAttrs.tips" class="el-upload__tip">{{btnAttrs.tips}}</div>
    </el-upload>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "baseUploadFile",
  props: {
    api: {
      type: String,
      default: "",
    },
    limit: {
      //最大个数限制
      type: Number,
      default: 1,
    },
    photoList: {
      // 图片列表
      type: [Array, String],
      default: () => [],
    },
    queryData: {
      //上传时附带的额外参数
      type: Object,
      default: () => { },
    },
    btnAttrs: {
      type: Object,
      default: () => {
        return {
          btnText: '点击上传',
          tips: ''
        }
      },
    },
    imgWid: {
      type: [Number, String],
      default: 0,
    },
    imgHei: {
      type: [Number, String],
      default: 0,
    },
  },
  data () {
    return {
      fileList: [],
      picUploadList: [], // 图片上传路径
      imgUrl: "",
      dialogImageUrl: "",
      isHide: false,
      loadProgress: 0, // 动态显示进度条
      progressFlag: false, // 关闭进度条
    };
  },
  computed: {},
  watch: {
    photoList: {
      handler (newV) {
        // console.log(newV)
        if (!newV) {
          return;
        }
        let list = [];
        this.fileList = [];
        if (Array.isArray(this.photoList)) {
          this.photoList.forEach((item) => {
            list.push({ url: item.url });
          });
          this.fileList = list;
        } else {
          //兼容一个图片传字符串的情况
          list.push({ url: newV });
          this.fileList = list;
        }

        this.isHide = this.fileList.length >= this.limit;
      },
      deep: true,
      immediate: true,
    },
  },

  mounted () {
    // this.fileList = this.photoList
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
        return false
      }
      var _this = this;
      //当图片传入了宽高时限制上传图片比例
      let isSize = "";
      // console.log(this.imgWid,this.imgHei)
      if (this.imgWid && this.imgHei) {

        isSize = new Promise((resolve, reject) => {
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          // console.log(img)
          img.onload = function () {
            // 比例限制
            const valid = img.width / img.height == _this.imgWid / _this.imgHei;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(
          () => {
            return file;
          },
          () => {
            this.$message.error(`上传图片宽高比值为${this.imgWid}*${this.imgHei}`);
            return Promise.reject();
          }
        );
      }

      if (this.imgWid && this.imgHei) {
        return isLt2M && isSize;
      } else {
        return isLt2M;
      }
      // console.log(isSize);

      // return isLt1M&&isSize;
    },
    handleChange (file, fileList) {
      // chang事件
      this.isHide = fileList.length >= this.limit;
    },
    async handleFileUpload (file) {
      let that = this;
      let baseURL = "http://api.ceshihr.com";
      if (that.$store.state.target === "https://api.zhangxiao7.com") {
        baseURL = that.$store.state.target;
      }
      let formData = new FormData();
      formData.append("file", file.file);
      if (JSON.stringify(this.queryData) != "{}") {
        for (let i in this.queryData) {
          formData.append(i, this.queryData[i]);
        }
      }

      let newURL = baseURL + this.api
      // console.log(newURL)
      //用原生的这种也可
      // const xhr = new XMLHttpRequest();
      // xhr.onreadystatechange = (data) => {
      //   if (xhr.readyState === 4 && xhr.status === 200) {
      //     let res = JSON.parse(xhr.responseText);
      //     if (res.code === 0) {
      //       this.$emit("confirm", res.data);
      //       this.$store.commit("MyMessage", "上传成功");
      //     } else {

      //     }
      //   }
      // };

      // xhr.open("POST", newURL);
      // xhr.setRequestHeader("token", sessionStorage.getItem("pc-tkn"));
      // xhr.send(formData);

      axios({
        url: newURL,
        method: 'post',
        headers: {
          "Content-type": "multipart/form-data;boundary=----WebKitFormBoundarynBqU9PJxeVlmgyya",
          "token": sessionStorage.getItem("pc-tkn")
        },
        data: formData,
      }).then((response) => {
        console.log(response)
        this.$message.success('操作成功')
        this.$emit("confirm", response.data);
      });
    },
  },
};
</script>

<style>
.upload {
  margin-bottom: 10px;
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
